import { useContext } from 'react';
import { AuthContext, AuthContextType } from '../contexts/AuthContextValue';

export function useAuth() {
  return useContext(AuthContext) as AuthContextType;
}
